import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { SdNavigationAccountComponent } from '@seb/web-design-system/navigation-account';
import { CoreModalService, ILink } from '@seb/web-design-system/core';

import { CustomCmsLinkComponent, NavigationBlocModuleInterface } from '../../../models';
import { AbstractModuleComponent } from '../abstract-module.component';
import { TrackingService } from '../../../services';
import { LinkMapper } from '../../../mappers';

@Component({
  selector: 'wc-navigation-bloc-module',
  templateUrl: './navigation-bloc-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdNavigationAccountComponent],
  providers: [CoreModalService]
})
export class NavigationBlocModuleComponent extends AbstractModuleComponent<NavigationBlocModuleInterface> implements OnInit {
  links: ILink[];

  constructor(
    private cdRef: ChangeDetectorRef,
    private trackingService: TrackingService
  ) {
    super();
  }

  override mandatoryComponentFunction = (link: CustomCmsLinkComponent): boolean => {
    return (!!link.url || !!link.urlLocalized) && !!link.linkName;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.module$.subscribe((module: NavigationBlocModuleInterface) => {
        this.links = module.componentsObjects.map(LinkMapper.cmsLinkToILink);
        this.setLoaded();
        this.cdRef.markForCheck();
      })
    );
  }

  onClicked(linkName: string): void {
    this.trackingService.sendEvent('clickNavigation', { navLevel: linkName });
  }
}
